import React from 'react';
import { H1, H2 } from '~typography';
import { helpersPropTypes } from '~helpers';
import ProductCheckout from '../ProductCheckout';
import ImageContainer from './ImageContainer';
import ImageWrapper from './ImageWrapper';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductCard = function ProductCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      imageDetails = _ref.imageDetails,
      imageWidth = _ref.imageWidth,
      price = _ref.price,
      currency = _ref.currency,
      discount = _ref.discount,
      availableStyles = _ref.availableStyles,
      onProductChange = _ref.onProductChange,
      onProductSubmit = _ref.onProductSubmit,
      isSubmitting = _ref.isSubmitting,
      index = _ref.index;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H1, null, title), subtitle && /*#__PURE__*/React.createElement(H2, null, subtitle), imageDetails && /*#__PURE__*/React.createElement(ImageContainer, {
    imageWidth: imageWidth
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    fluid: imageDetails
  })), /*#__PURE__*/React.createElement(ProductCheckout, {
    price: price,
    currency: currency,
    discount: discount,
    availableStyles: availableStyles,
    onProductChange: onProductChange,
    onProductSubmit: onProductSubmit,
    index: index,
    isSubmitting: isSubmitting
  }));
};

ProductCard.defaultProps = {
  subtitle: undefined,
  imageDetails: null,
  discount: undefined,
  isSubmitting: false,
  imageWidth: undefined
};
export default ProductCard;